var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"printTest"},[_c('p',[_c('button',{on:{"click":_vm.generatePDFProcess}},[_vm._v(" Generate PDF ")])]),_c('p',[_c('button',{on:{"click":_vm.generatePDFProtocol}},[_vm._v(" Generate PDF ver2 ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }